import React from 'react';
import './i18n';
// **** Main CSS **** 
import './assets/scss/main.scss';
import Navigation from '../src/navigation';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import store from './store';
import { ToastProvider } from './context/ToastContext';
import { TranslationProvider } from './context/TranslationContext';
import { plausible } from './utils/plausibleTracker';
import MaintenancePageProvider from './context/MaintenanceContext';

function App() {
  const queryClient = new QueryClient();
  plausible.enableAutoPageviews();
  return (
    <Provider store={store} >
      <QueryClientProvider client={queryClient}>
        <TranslationProvider>
          <ToastProvider >
            <MaintenancePageProvider>
              <Navigation />
            </MaintenancePageProvider>
          </ToastProvider>
        </TranslationProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;